<template>
  <div id="register">
    <!-- 用户登录 -->
    <el-row class="logincenter">
      <el-col :span="8">&nbsp;</el-col>
      <el-col :span="8" style="text-align:center" >
        <div class="login-form" @mouseenter="enter()" @mouseleave="leave()">
          <div class="filed left">
            <i class="iconfont icou"></i>
            <span class="formTitleStyle">用户注册</span>
            <span class="signstyle">已有账户?
              <a @click="open()">去登录</a>
            </span>
          </div>
          <form autocomplete="off" name="reg-form">
            <div class="filed">
              <el-input v-model="REAunscid" name="REAunscid" id="REAunscid" placeholder="请输入统一社会信用代码"
                prefix-icon="iconfont icon-login-validate" @blur="tyshxydmCheck"></el-input>
              <p class="alert1" v-show="tyshxydmAlertFlag">*统一社会信用代码为18位数字字母组合</p>
              <p class="alert1" v-show="tyshxydmAlertFlag2">*统一社会信用代码已被注册</p>
            </div>
            <div class="filed">
              <el-input type="text" class="inputstyle" v-model="mobile" name="mobile" id="mobile" placeholder="请输入手机号"
                prefix-icon="iconfont icon-login-phone" @blur="mobileCheck">
                <template slot="suffix">
                  <el-button type="button" id="mobile-btn" class="verficode phonebtn" @click="getMessageCode()" v-text="messageCodeText"
                    :disabled="mobileBtnDisabled"></el-button>
                </template>
              </el-input>
              <p class="alert" v-show="mobileAlertFlag">*请填写正确的手机号码</p>
            </div>
            <div class="filed">
              <el-input v-model="messageCode" name="messageCode" id="messageCode" placeholder="请输入手机验证码" @blur="messageCodeCheck"
                prefix-icon="iconfont icon-login-validate"></el-input>
              <p class="alert1" v-show="messageCodeAlertFlag">*{{ msg }}</p>
            </div>
            <div class="filed">
              <el-input placeholder="请输入密码" prefix-icon="iconfont icon-login-password" type="password" class="inputstyle"
                v-model="password1" name="password1" id="password1" @blur="password1Check"></el-input>
              <p class="alert2" v-show="password1AlertFlag" style="font-size:10px">*密码应为8-30位字母和数字组合</p>
            </div>
            <div class="filed">
              <el-input type="password" class="inputstyle" v-model="password2" name="password2" id="password2"
                placeholder="请再次输入密码" @blur="password2Check" prefix-icon="iconfont icon-login-checkpass"></el-input>
              <p class="alert3" v-show="password2AlertFlag">*两次密码不一致</p>
            </div>

            <div class="filed right">
              <span class="muchtab">
                <!-- <router-link :to="{path:'/exhibition/login/ch/ForgetUsername'}"><a>忘记用户名</a></router-link> | -->
                <router-link :to="{path:'/exhibition/login/ch/ForgetPassword'}"><a>忘记密码</a></router-link> |
                <router-link :to="{path:'/exhibition/login/ch/Reset'}"><a>重置账户</a></router-link>
              </span>
            </div>
            <div class="lgin">
              <el-button type="danger" @click="register()" round>注册</el-button>
            </div>
          </form>
        </div>
      </el-col>
      <el-col :span="8">&nbsp;</el-col>
    </el-row>
    <!-- <el-dialog custom-class="registerDialogWidth" title="请填写企业基本信息完成注册" :visible.sync="qyjbxxShow" :close-on-click-modal="false" :append-to-body="true">
      <registerBaseInfo ref="registerBaseInfo" :username="mobile" :password="password1" :REAunscid="REAunscid" :messageCode="messageCode"></registerBaseInfo>
    </el-dialog> -->

    

  </div>
  
</template>

<script>
//引入
import registerBaseInfo from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/RegisterBaseInfo'
  export default {
    components: {
      registerBaseInfo
    },
    name: "Register",
    data() {
      return {
        //注册
        time: 60,
        timer: null,
        mobile: "",
        messageCode: "",
        messageCodeReal: "",
        messageCodeText: "获取验证码",
        password1: "",
        password2: "",
        mobileBtnDisabled: false,
        REAunscid: "",
        //注册校验标识
        mobileAlertFlag: false,
        messageCodeAlertFlag: false,
        password1AlertFlag: false,
        password2AlertFlag: false,
        tyshxydmAlertFlag: false,
        tyshxydmAlertFlag2: false,

        //add by yushch 20220920
        qyjbxxShow: true,
        msg:"验证码不正确",
        
    
      };
    },
    methods: {
      //校验
      //消息提示框
      open() {
        if (this.mobile != '' || this.messageCode != '' || this.password1 != '' || this.password2 != '') {
          this.$confirm("未保存的数据将丢失，确定返回吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              path: "/exhibition/login/ch/login"
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.$router.push({
            path: "/exhibition/login/ch/login"
          });
        }
      },
      //验证手机号
      mobileCheck() {
        if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
          this.mobileAlertFlag = true;
          return false;
        } else {
          this.mobileAlertFlag = false;
          return true;
        }
      },
      //获取手机验证码
      getMessageCode() {
        let vm = this;
        vm.messageCode = "";
        if (vm.mobileCheck()) {
          vm.messageCodeText = "发送中...";
          vm.mobileBtnDisabled = true;
          vm.$axios.get("/signin/getUsernameNum/" + vm.mobile + "/static").then(
            function(res) {
              if (res.data.result != 0) {
                vm.$message({
                  type: "error",
                  message: "用户名已存在！"
                });
                vm.messageCodeText = "获取验证码";
                vm.mobileBtnDisabled = false;
              } else {
                let params={
                  sjhm: vm.mobile,
                  dxlx: "ZC"
                }
                vm.$axios.post("/signin/sendMessage2", params).then(
                  function(res) {
                    if (res.data.code == '00000000') {
                      //vm.messageCodeReal = res.data.msg;
                      var count = vm.time;
                      vm.timer = setInterval(() => {
                        if (count == 0) {
                          clearInterval(vm.timer);
                          vm.timer = null;
                          vm.messageCodeText = "获取验证码";
                          vm.mobileBtnDisabled = false;
                        } else {
                          vm.messageCodeText = count + "秒后获取";
                          count--;
                          vm.mobileBtnDisabled = true;
                        }
                      }, 1000);
                    } else if (res.data.code == '66666666') {
                      this.$message.error("您发送的短信过于频繁，请稍后再试");
                      vm.messageCodeText = "获取验证码";
                      vm.mobileBtnDisabled = false;
                    } else if (res.data.code == '99999999') {
                      this.$message.error("短信发送失败");
                      vm.messageCodeText = "获取验证码";
                      vm.mobileBtnDisabled = false;
                    } else{
                      this.$message.error(res.data.msg);
                      vm.messageCodeText = "获取验证码";
                      vm.mobileBtnDisabled = false;
                    }
                  }.bind(vm),
                  function(error) {
                    console.log(error);
                  }
                );
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
        }
      },
      //手机验证码校验
      messageCodeCheck() {
        /*
        if (!/^[0-9a-zA-Z]{6}$/.test(this.messageCode)) {
          this.messageCodeAlertFlag = true;
          return false;
        } else {
          this.messageCodeAlertFlag = false;
          return true;
        }
        */
        //验证码相等且不为空
        // if (this.messageCode == this.messageCodeReal && this.messageCodeReal != "") {
        if(/^\d{6}$/.test(this.messageCode) ){
          this.messageCodeAlertFlag = false;
          return true;
        } else {
          this.messageCodeAlertFlag = true;
          return false;
        }
      },
      //密码校验
      password1Check() {
        //if (!/(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/.test(this.password1)) {
        if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/.test(this.password1)) {
          this.password1AlertFlag = true;
          return false;
        } else {
          this.password1AlertFlag = false;
          return true;
        }
      },

      //确认密码校验
      password2Check() {
        if (this.password1 !== this.password2) {
          this.password2AlertFlag = true;
          return false;
        } else {
          this.password2AlertFlag = false;
          return true;
        }
      },
      //注册
      register() {
        let vm = this;
        vm.mobileCheck();
        vm.messageCodeCheck();
        vm.password1Check();
        vm.password2Check();
        vm.tyshxydmCheck();
    if ((!this.tyshxydmAlertFlag) && (!this.tyshxydmAlertFlag2) && vm.mobileCheck() && vm.messageCodeCheck() && vm.password1Check() && vm.password2Check()) {
          //modify by yushch 20220921注册时填写企业基本信息
          // var params = {
          //   username: vm.mobile,
          //   password: vm.password1,
          //   usertype: "CHN",
          //   deptid: "ZSYH"
          // };
          // vm.$axios.post("/signin/insertByVO", params).then(
          //   function(res) {
          //     this.$message({
          //       type: "success",
          //       message: "注册成功！"
          //     });
          //     vm.username = vm.mobile;
          //     vm.password = vm.password1;
          //     //vm.changeForm("loginFlag");
          //     vm.$router.push({
          //       name: "exhibition/login/ch/Login",
          //       query: {
          //         username: vm.username,
          //         password: vm.password,
          //         type: 'register'
          //       }
          //     });
          //   }.bind(vm),
          //   function(error) {
          //     console.log(error);
          //   }
          // );

           //校验验证码 add by yushch 260409
          let params = {
            sjhm: this.mobile,
            yzm: this.messageCode,
            dxlx: "ZC"
          }
          vm.$axios.post('/dx/checkCode', params).then(function(res) {
            if (res.data.code == '00000000') {
              this.qyjbxxShow = true;
            } else {
              //vm.$message.error(res.data.msg);
              vm.msg = res.data.msg
              vm.messageCodeAlertFlag = true;
            }
          }.bind(vm), function(error) {
            console.log(error);
          });
          //yushch end

          //this.qyjbxxShow = true;
        }
      },

      //add by yushch 20220919 统一社会信用代码校验唯一
      tyshxydmCheck: function(){
        if (!(/^[A-Za-z0-9 ]{18}$/.test(this.REAunscid))) {
          this.tyshxydmAlertFlag = true;
          return false;
        } else {
          this.tyshxydmAlertFlag = false;
          let tyshxydm = this.REAunscid.replace(/ /g, "");
          var params = {
            tyshxydm: tyshxydm,
            deleteFlag: "N"
          };
          this.$axios.post("/qykpxx/list", params).then(
            function(res) {
              if(res.data.result.length > 0){
                this.$confirm('统一社会信用代码已被注册，请通过手机号直接登录。<br>如忘记手机号，可通过重置账户功能重置，<br>是否立即重置？', '提示', {
                  confirmButtonText: '去重置',
                  cancelButtonText: '取消',
                  type: 'warning',
                  dangerouslyUseHTMLString: true
                }).then(() => {
                  this.$router.push({
                    path:'/exhibition/login/ch/Reset'
                  });
                  
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });          
                });

                // this.$alert(
                //   '统一社会信用代码已被注册，请通过手机号直接登录。<br>如忘记手机号，可通过重置账户功能重置。', 
                //   '提示', 
                // {
                //   confirmButtonText: '确定',
                //   type: 'warning',
                //   dangerouslyUseHTMLString: true
                // });
                this.tyshxydmAlertFlag2 = true;
                return false;
              }else{
                this.tyshxydmAlertFlag2 = false;
                return true;
              }
              }.bind(this),
            function(error) {
              return false;
              console.log(error);
            }
          );
        }
      },
      //add by yushch 鼠标进入注册界面时调整z-index 解决注册按钮被遮挡问题
      enter: function(){
        var footer = document.getElementById('footer');
        footer.style.cssText="z-index:-1000";
      },
      leave: function(){
        var footer = document.getElementById('footer');
        footer.style.cssText="z-index:1000";
      },

    }
  };
</script>

<style lang="scss">
  .registerDialogWidth{
      width: 65%;
    }
  #register {
    @import "@/common/scss/login.scss";

    /deep/.el-input {
      height: 3rem !important;
    }

    .el-input__inner {
      height: 3rem;
      line-height: 3rem;
    }

    .lgin {
      margin-top: 1.5rem;
    }

    // .login-form {
    //   height: 31rem;
    // }
    a {
      text-decoration: none;
      color: #2452ff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/exhibition/login/ch/Register.vue